import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {SharedModule} from 'shared';
import {WalksComponent} from './walks.component';
import {WalkCardComponent} from './walk-card/walk-card.component';

@NgModule({
  declarations: [
    WalksComponent,
    WalkCardComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild([
      {
        path: '',
        component: WalksComponent
      }
    ])
  ]
})
export class WalksModule {
}
